import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderBatchAllocationsService = {

  async getSalesOrderDetailsByCode(params) {
    const requestScreenData = {
      url: "api/SalesOrderDetailCompanyBranch",
    };

    if (params) {
      if (params.filter) requestScreenData.filter = params.filter;
      if (params.select) requestScreenData.select = params.select;
      if (params.top != undefined) requestScreenData.top = params.top;
      if (params.orderby) requestScreenData.orderby = params.orderby;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductBatchAllocation(params) {
    const requestScreenData = {
      url: "api/ProductBatchAllocation",
      orderby: "UseByDate asc,BestBeforeDate asc,ManufacturedDate asc,DateCreated asc"
    };

    if (params) {
      if (params.filter) requestScreenData.filter = params.filter;
      if (params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getGetProductionBatchAllocationEdit(TransacitonNo) {

    const requestScreenData = {
      url: "api/GetProductBatchAllocation/" + TransacitonNo + "/ISO",
      // sort: "UseByDateForSort asc,BestBeforeDateForSort asc,DateCreated asc",
      orderby: "BatchDetails.UseByDate asc,BatchDetails.BestBeforeDate asc,BatchDetails.ManufacturedDate asc,BatchDetails.DateCreated asc"
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBatchAllocationRule() {

    const requestScreenData = {
      url: "api/BatchAllocationRule",
      // filter: `BranchCode eq '${BranchCode}'`
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveBatchAllocation(payload) {
    var url = "api/ProductBatchAllocation";
    return await ApiService.post(url, payload);
  },
};

export { SalesOrderBatchAllocationsService };
